import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { KeysPipe } from '../../keyspipe.pipe';
import { LoginServicesService } from '../../services/login-services.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-auth-code-form',
    imports: [ReactiveFormsModule, FormsModule, CommonModule, KeysPipe, DialogModule, ButtonModule],
    providers: [KeysPipe],
    templateUrl: './auth-code-form.component.html',
    styleUrl: './auth-code-form.component.scss'
})
export class AuthCodeFormComponent {
  visible = true;
  isValidating = false;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() resendLogin: EventEmitter<any> = new EventEmitter<any>();
  @Input() phoneNumber!: string;
  @Input() clientNumber!: number;
  @Input() password!: string;

  OTPForm: FormGroup;
  otp!: string;
  otpError = false;
  otpMessage = '';
  timer = 30;
  canResend = false;
  private countdownId: any;

  constructor(
    private service: LoginServicesService,
    private keysPipe: KeysPipe
  ) {
    this.OTPForm = new FormGroup({});
  }

  getFormControl(item: string | number): FormControl {
    return this.OTPForm?.controls[item] as FormControl;
  }

  ngOnInit(): void {
    this.startTimerResend();
    for (let index = 0; index < 4; index++) {
      this.OTPForm.addControl('ctrl_' + index, new FormControl());
    }
    // Auto-focus primer input y habilitar paste tras renderizar el dialog
    setTimeout(() => {
      const container = document.getElementById('c');
      if (container) {
        container.addEventListener('paste', (e) => this.handlePaste(e));
        const el = document.getElementById('otp_0');
        if (el) el.focus();
      }
    }, 200);
  }

  private handlePaste(e: ClipboardEvent) {
    e.stopPropagation();
    e.preventDefault();
    const pastedData = e.clipboardData?.getData('Text');
    if (!pastedData || isNaN(Number(pastedData))) return;
    const value = pastedData.replace(/\s/g, '');
    this.OTPForm.reset();
    Array.from(value).forEach((c, idx) => {
      const ctrl = this.OTPForm.get('ctrl_' + idx);
      if (ctrl) ctrl.setValue(c);
    });
    this.rebuildValue();
    const focusIdx = Math.min(value.length, 3);
    this.focusTo('otp_' + focusIdx);
  }

  ngOnDestroy(): void {
    if (this.countdownId) clearInterval(this.countdownId);
  }

  onKeyDown($event: any): any {
    if ($event.keyCode === 32) return false; // prevent space
  }

  onKeyUp($event: any, inputIdx: number) {
    const nextId = `otp_${inputIdx + 1}`;
    const prevId = `otp_${inputIdx - 1}`;

    if ($event.keyCode === 39) { this.focusTo(nextId); return; }
    if ($event.keyCode === 37) { this.focusTo(prevId); return; }

    const isBackspace = $event.key === 'Backspace' || $event.key === 'Delete';
    if (isBackspace && !$event.target.value) {
      this.focusTo(prevId);
      this.rebuildValue();
      return;
    }
    if (!$event.target.value) return;

    const inp = String.fromCharCode($event.keyCode);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile || /[0-9]/.test(inp) || ($event.keyCode >= 96 && $event.keyCode <= 105)) {
      this.focusTo(nextId);
    }
    this.rebuildValue();
  }

  private focusTo(eleId: string) {
    const ele = document.getElementById(eleId) as HTMLInputElement;
    if (ele) {
      ele.focus();
      setTimeout(() => ele.setSelectionRange(0, 1), 0);
    }
  }

  private rebuildValue() {
    let val = '';
    this.keysPipe.transform(this.OTPForm.controls).forEach((k) => {
      if (this.OTPForm.controls[k].value) val += this.OTPForm.controls[k].value;
    });
    this.otp = val;
  }

  close(resp: any) {
    this.visible = false;
    this.closeModal.emit(resp);
  }

  verifyOTP() {
    this.isValidating = true;
    this.service.login2FA(this.clientNumber.toString(), this.password, this.otp).subscribe({
      next: (resp: any) => {
        this.isValidating = false;
        if (resp.isSuccess === false || resp.error) {
          this.otpError = true;
          this.otpMessage = resp.message;
        } else {
          this.otpError = false;
          this.otpMessage = 'Código validado con éxito, serás redirigido en unos segundos';
          setTimeout(() => this.close(resp), 2000);
        }
      },
      error: (err: any) => {
        this.isValidating = false;
        this.otpError = true;
        this.otpMessage = (err.error?.error || 'Error al verificar') + ', intenta de nuevo';
      }
    });
  }

  resend() {
    this.canResend = false;
    this.resendLogin.emit(true);
    this.startTimerResend();
  }

  startTimerResend() {
    this.timer = 30;
    this.countdownId = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(this.countdownId);
        this.canResend = true;
      }
    }, 1000);
  }
}
